<template>

    <div class="percent">
      <div class="item">
        <span>轴承温度_滚筒非驱动侧_北车</span>
        <centerChart class="item-rate" v-if="childShow" :id="tempData[0].id" :eocId="tempData[0].eocId"/>
      </div>
      <div class="item">
        <span>轴承温度_滚筒非驱动侧_南车</span>
        <centerChart class="item-rate" v-if="childShow" :id="tempData[1].id" :eocId="tempData[1].eocId"/>
      </div>
      <div class="item">
        <span>轴承温度_滚筒驱动侧_北车</span>
        <centerChart class="item-rate" v-if="childShow" :id="tempData[2].id" :eocId="tempData[2].eocId"/>
      </div>
      <div class="item">
        <span>轴承温度_滚筒驱动侧_南车</span>
        <centerChart class="item-rate" v-if="childShow" :id="tempData[3].id" :eocId="tempData[3].eocId"/>
      </div>
    </div>

</template>

<script>


import centerChart from "@/views/em/kpiLayout/charts/centerChartRate";
import EmCommonApi from "@/mixin/em/common/api";

export default {
  name: "echartCenterBottom",
  mixins: [EmCommonApi],
  components:{centerChart},
  data(){
    return{
      childShow: false,
      tempData: [
        {
          //轴承温度_滚筒非驱动侧_北车
          id: "em1",
          eocId: "",  //computedId
        },
        {
          //轴承温度_滚筒非驱动侧_南车
          id: "em2",
          eocId: "",  //computedId
        },
        {
          // 轴承温度_滚筒驱动侧_北车
          id: "em3",
          eocId: "",  //computedId
        },
        {
          // 轴承温度_滚筒驱动侧_北车
          id: "em4",
          eocId: "",  //computedId
        }
      ]
    }
  },
  created() {
    //this.getRemoteData()  //TODO 2021.12.10 ID参数传不进去，暂时不启用
  },
  mounted() {
    //定时轮巡查询
        this.fresh = setInterval(() => {
          this.getRemoteData();
          //window.addEventListener('resize', this.chart.resize, false)
        },  10000);
  },
  computed:{
  },
  methods:{
    getRemoteData(){
      const _api = this.$_emApiMixin_moduleBaseApi("emSicBoardPointSdp") +
          "/emSicBoardPointSdp/getComputedIdList?code=" + "2-3"   //这里写死了模块的code，注意对应

      // console.log("计算属性IdList！！！！")
      // console.log(_api)
      this.$_emApiMixin_get(_api)
          .then((res) => {
            // console.log("提监控看板模块idLists：")
            // console.log(res)

            //TODO （这里没有用到）取到的计算属性ID参数传不过去，部署前端先改一下吧
            var optionArr = [];  //定义一个数组用来存放
            this.tempData.map((item,index)=>{    //  把原数组循环一下
              optionArr.push(
                  Object.assign(item,{eocId:res[index]})     //  数组的每一行添加一个 disabled:'true'  属性
              )});

            this.childShow = true;  //父组件请求点位id完毕，然后启用子组件显示刷新，否则加载时子组件立刻显示props是空报错
            // console.log(this.tempData)
          })
    }
  }

}
</script>

<style lang="scss" scoped>

      .percent {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .item {
          width: 25%;
          height: 5rem;

          span {
            margin-top: 2rem;
            line-height: 2rem;
            font-size: 1rem;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
          }

          .item-rate{
            display: flex;
            justify-content: center;
          }
        }
      }

</style>